import type {Theme} from '../theme';
import {createBaseThemeVariation} from './base';

export const NuffieldHealthTheme: Theme = createBaseThemeVariation({
    name: 'nuffieldhealth',
    brandColor: 'hsla(120, 100%, 32%, 1)',
});
